import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { MainComponent } from './main.component';
import { TopBarComponent } from './components/topbar/topbar.component';
import { MenuComponent } from './components/menu/menu.component';
import { FooterComponent } from './components/footer/footer.component';
import { ExternalApplicationsFormComponent } from './components/external-applications/external-applications-form/external-applications-form.component';
import { PortalDAO } from './daos/portal.dao';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { SharedModule } from 'primeng/api';
import { PanelModule } from 'primeng/panel';
import { CheckboxModule } from 'primeng/checkbox';
import { PaginatorModule } from 'primeng/paginator';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RippleModule } from 'primeng/ripple';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MenuModule } from 'primeng/menu';
import { TableModule } from 'primeng/table';
import { SidebarModule } from 'primeng/sidebar';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DropdownModule } from 'primeng/dropdown';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { TabMenuModule } from 'primeng/tabmenu';
import { CardModule } from 'primeng/card';
import { ToastModule } from 'primeng/toast';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { SkeletonModule } from 'primeng/skeleton';
import { BadgeModule } from 'primeng/badge';
import { DataViewModule } from 'primeng/dataview';
import { SharedComponentsModule } from './components/shared/shared-components.module';
import { CalendarModule } from 'primeng/calendar';
import { InputSwitchModule } from 'primeng/inputswitch';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { StepsModule } from 'primeng/steps';
import { TimelineModule } from 'primeng/timeline';
import { TranslocoRootModule } from './i18n/transloco-root.module';
import { TranslocoModule } from '@ngneat/transloco';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { TagModule } from 'primeng/tag';
import { ToolbarModule } from 'primeng/toolbar';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputMaskModule } from 'primeng/inputmask';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { LandingModule } from './components/landing/landing.module';
import { ColorPickerModule } from 'primeng/colorpicker';
import { FileUploadModule } from 'primeng/fileupload';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { OAuthModule, OAuthService } from 'angular-oauth2-oidc';
import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import { AppHttpInterceptor } from './common/http-interceptor/filtered-http';
import { InitialAuthService } from './common/initialauth.service';
import { DividerModule } from "primeng/divider";
import { AvatarModule } from "primeng/avatar";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { ApplicationSettingsComponent } from './components/application-settings/application-settings.component';
import { CustomDatePipe } from "./shared/custom-date.pipe";
import { PreviewListComponent } from './components/application-settings/preview-list/preview-list.component';
import { SelectButtonModule } from "primeng/selectbutton";
import { ImageModule } from "primeng/image";
import { NotFoundComponent } from "./components/not-found/not-found.component";
import { UserSettingsComponent } from './components/user-settings/user-settings.component';
import { PreviewFormComponent } from './components/application-settings/preview-form/preview-form.component';
import { PreviewDetailsComponent } from './components/application-settings/preview-details/preview-details.component';
import { ConfirmDialogModule } from "primeng/confirmdialog";


@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    TopBarComponent,
    MenuComponent,
    FooterComponent,
    ExternalApplicationsFormComponent,
    ApplicationSettingsComponent,
    CustomDatePipe,
    PreviewListComponent,
    NotFoundComponent,
    UserSettingsComponent,
    PreviewFormComponent,
    PreviewDetailsComponent
  ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        HttpClientModule,
        FormsModule,
        CheckboxModule,
        PaginatorModule,
        ButtonModule,
        PanelModule,
        TableModule,
        SharedModule,
        RippleModule,
        ProgressSpinnerModule,
        MenuModule,
        SidebarModule,
        InputTextModule,
        RadioButtonModule,
        InputTextareaModule,
        DropdownModule,
        TriStateCheckboxModule,
        MultiSelectModule,
        TabMenuModule,
        CardModule,
        ToastModule,
        MessagesModule,
        MessageModule,
        SkeletonModule,
        BadgeModule,
        DataViewModule,
        SharedComponentsModule,
        CalendarModule,
        InputSwitchModule,
        NgxJsonViewerModule,
        StepsModule,
        ReactiveFormsModule,
        TimelineModule,
        TranslocoRootModule,
        ToggleButtonModule,
        TagModule,
        ToolbarModule,
        InputNumberModule,
        InputMaskModule,
        NgxIntlTelInputModule,
        LandingModule,
        ColorPickerModule,
        FileUploadModule,
        ConfirmPopupModule,
        OAuthModule.forRoot({
            resourceServer: {
                sendAccessToken: true
            }
        }),
        DividerModule,
        AvatarModule,
        OverlayPanelModule,
        SelectButtonModule,
        ImageModule,
        ConfirmDialogModule
    ],
  exports: [
    TranslocoModule
  ],
  providers: [
    PortalDAO,
    MessageService,
    ConfirmationService,
    {provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true},
    InitialAuthService,
    {
      provide: APP_INITIALIZER,
      useFactory: (initialAuthService: InitialAuthService) => () => initialAuthService.initAuth(),
      deps: [InitialAuthService],
      multi: true
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
